<script lang="ts">
  export let caneData: any;
  export let size: number;

  const builtinResFactor = 2;
  export let resFactor: number = builtinResFactor;

  import P5 from "p5-svelte";
  import PwtsLib from '@ludans/murano-fantasy';
  import newUniqueId from 'locally-unique-id-generator';

  let rendering = true;
  const eltId = newUniqueId();

  const sketch = (p) => {
    const sizeWithFactor = size * resFactor / builtinResFactor;
    p.setup = () => {
      p.createCanvas(sizeWithFactor, sizeWithFactor);
      p.noLoop();
    };

    p.draw = () => {
      PwtsLib.drawCane(p, caneData, sizeWithFactor);
      rendering = false;

      const elt = document.querySelector("#" + eltId);
      const canvasElt = <HTMLElement>elt.childNodes.item(0).childNodes.item(0);
      canvasElt.style.width = canvasElt.style.height = size + 'px';
    };
  };
</script>

<span id={eltId} aria-busy={rendering}>
  <P5 {sketch} />
</span>
